import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  Button,
} from "@material-ui/core";
import { useStore } from "@store/store";
import Loader from "@components/loader";
import { preshiftQuestionsHeader } from "@utils/constant";
import { TableStyle } from "./style";
import { Edit, Delete, DragIndicator } from "@material-ui/icons";

function PreshiftTable(props) {
  const [state, ] = useStore();
  const classes = TableStyle();

  return (
    <>
      <div className={classes.TableWrapper}>
        <Loader
          loading={ 
            state?.driver?.gettingPreshiftQuestions || 
            state?.driver?.updatingPreshiftQuestionOrder
          }
        />
        <TableContainer component={Paper} className={classes.customTable}>
          <Table
            className="preshift-question-table"
            aria-label="simple table"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                { preshiftQuestionsHeader?.map((item, index) => {
                  return (
                    <TableCell className={item.className} key={index}>
                      {item.title}
                      {item.sort && (
                        <TableSortLabel
                          direction={props.orderBy === "displayOrder" ? props.order : "asc"}
                          active={true}
                          onClick={(e) => props.handleSorting(e, item)}
                        />
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              { props?.preshiftQuestions?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3}>No Data Found</TableCell>
                </TableRow>
              ) : (
                props?.preshiftQuestions?.map((item, index) => {
                  return (
                    <TableRow 
                      key={item.id}
                      draggable
                      className={props.dragIndex !== null ? "dragging" : ""}
                      onDragStart={(event) => props?.handleDragStart(index, event)}
                      onDragOver={(event) => {
                        props?.handleDragOver(index, event);
                      }}
                      onDragEnd={ props?.handleDragEnd }
                      onDrop={() => props?.handleDrop(item?.id, index)}
                    >
                      <TableCell className="order">
                        <span
                          className="drag-area"
                          onMouseDown={() => {
                            if (props?.draggingEnabled) {
                              props.draggingEnabled.current = true;
                            }
                          }}
                          onMouseUp={() => {
                            if (props?.draggingEnabled) {
                              props.draggingEnabled.current = false;
                            }
                          }}
                        >
                          <DragIndicator className="drag" /><span>{item?.displayOrder || "-"}</span>
                        </span>
                      </TableCell>
                      <TableCell className="question-text">
                        {item?.questionTxt || "-"}
                      </TableCell>
                      <TableCell className="action">
                        <Button className="editBtn" onClick={() => props?.handleEdit(item)}>
                          <Edit className="sub-icon edit" /><span>Edit</span>
                        </Button>
                        <Button className="deleteBtn" onClick={() => props?.handleDelete(item)}>
                          <Delete className="sub-icon delete" /><span>Delete</span>
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
export default PreshiftTable;
